import { render } from "./SettingsSecurity.vue?vue&type=template&id=3c6b7e46&scoped=true"
import script from "./SettingsSecurity.vue?vue&type=script&lang=js"
export * from "./SettingsSecurity.vue?vue&type=script&lang=js"

import "./SettingsSecurity.vue?vue&type=style&index=0&id=3c6b7e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6b7e46"]])

export default __exports__